import { dwsStartedComponent } from './started.component';

export const dwsStartedStateName = 'app.ticket.dwsReceivingStarted';

export const dwsStartedState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: dwsStartedStateName,
    url: '/dwsStarted',
    component: dwsStartedComponent.name,
    data: { requiresAuth: true },
  });
};
